export default "__VITE_ASSET__DESX2lc$__"